import { useEffect, useState } from "react";

const Dots = () => {
  const [visibleDots, setVisibleDots] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleDots((prev) => (prev === 5 ? 1 : prev + 1));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex w-full h-full gap-8 justify-center items-center absolute">
      {Array.from(
        { length: 5 },
        (_, index) =>
          index < visibleDots && (
            <div
              key={index}
              className="rounded-full h-5 w-5 bg-white animate-ping z-10"
            />
          )
      )}
    </div>
  );
};

export default Dots;
